/* eslint-disable */
import React from 'react';
import {
  Drawer,
  Box,
  IconButton,
  Typography,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import { Close as CloseIcon, FilterList } from '@mui/icons-material';
import { Filters } from './Filters';
import type { FilterOptions } from '../../hooks/useRelease';

interface FiltersDrawerProps {
  open: boolean;
  onClose: () => void;
  filters: FilterOptions;
  filterOptions: {
    statuses: string[];
    types: string[];
    assignees: string[];
    productScopes: string[];
    swTeams: string[];
  };
  onFiltersChange: (filters: FilterOptions) => void;
}

export const FiltersDrawer: React.FC<FiltersDrawerProps> = ({
  open,
  onClose,
  filters,
  filterOptions,
  onFiltersChange,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Drawer
      anchor={isMobile ? 'bottom' : 'right'}
      open={open}
      onClose={onClose}
      variant={isMobile ? 'temporary' : 'persistent'}
      PaperProps={{
        sx: {
          width: { xs: '100%', md: 360 },
          height: { xs: '80vh', md: '100%' },
          borderLeft: { md: `1px solid ${theme.palette.divider}` },
        },
      }}
    >
      <Box sx={{ p: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <FilterList />
            <Typography variant="h6">Filters</Typography>
          </Box>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
        <Filters
          filters={filters}
          filterOptions={filterOptions}
          onFiltersChange={onFiltersChange}
        />
      </Box>
    </Drawer>
  );
};
